import React, {Fragment, useEffect} from 'react';
import TableHead                    from '@mui/material/TableHead';
import MaterialTable                from '@mui/material/Table';
import TableRow                     from '@mui/material/TableRow';
import TableCell                    from '@mui/material/TableCell';
import TableContainer               from '@mui/material/TableContainer';
import Row                          from './Row';
import {useTranslation}             from 'react-i18next';
import Empty                        from './Empty';
import TableBody                    from '@mui/material/TableBody';
import TableFooter                  from '@mui/material/TableFooter';
import {connect}                    from 'react-redux';
import Pagination                   from '../../../../data/table/Pagination';
import {
	fetchShippingFees,
	setShippingFeeFilters,
	setShippingFeePaging
}                                   from '../../../../../../store/actions/store/ShippingFeeAction';

const Table = ({fees, fetch, loading, filters, paging, count, setShippingFeePaging, setShippingFeeFilters}) => {
	const loadingData = [...Array(paging.results_per_page).keys()];
	const {t} = useTranslation();
	const displayLoading = () => loadingData.map((k) => <Row
		key={k}
		loading={true}
		fee={null}
	/>);

	const displayFees = () => fees.map((u, idx) => <Row key={u.Catalog_Deliverable_Fee__}
	                                                    loading={false}
	                                                    fee={u}/>);

	useEffect(() => {
		// Reset filters the first time
		setShippingFeeFilters({...filters});
		// eslint-disable-next-line
	}, [setShippingFeeFilters]);


	useEffect(() => {
		fetch();
	}, [fetch, filters, paging]);

	/*const {sort} = filters;

	const sortHandler = (property, dir) => {
		let p = {...filters};
		// only 1 sort
		p.sort = {};
		p.sort[property] = dir;
		setRecordsFilters(p);
	};*/

	return (
		<Fragment>
			{(loading || fees.length > 0) &&
			<TableContainer>
				<MaterialTable aria-label="simple table">
					<TableHead>
						<TableRow>
							<Pagination
								setPaging={setShippingFeePaging}
								paging={paging}
								loading={loading}
								count={count}
							/>
						</TableRow>
						<TableRow>
							<TableCell> {t('tablecell_shipping_fee_name')}</TableCell>
							<TableCell> {t('tablecell_shipping_fee_type')}</TableCell>
							<TableCell align="right"/>
						</TableRow>
					</TableHead>
					<TableBody>
						{loading && displayLoading()}
						{!loading && displayFees()}
					</TableBody>
					<TableFooter>
						<TableRow>
							<Pagination
								setPaging={setShippingFeePaging}
								paging={paging}
								loading={loading}
								count={count}
							/>
						</TableRow>
					</TableFooter>

				</MaterialTable>
			</TableContainer>
			}
			{(!loading && fees.length < 1) && <Empty/>}
		</Fragment>
	);

};


const mapStateToProps = (state) => {
	return {
		filters: state.shippingFee.feesFilters,
		paging: state.shippingFee.feesPaging,
		count: state.shippingFee.feesPagingCount,
		loading: state.shippingFee.feesLoading,
		fees: state.shippingFee.fees,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetch: () => dispatch(fetchShippingFees()),
		setShippingFeePaging: (newPaging) => dispatch(setShippingFeePaging(newPaging)),
		setShippingFeeFilters: (newFilters) => dispatch(setShippingFeeFilters(newFilters)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);

